
export const getComID = () => import.meta.env.VITE_COM_ID